import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  infoTooltip: {
    maxWidth: '320px',
  },
  infoTooltipIcon: {
    marginLeft: '5px',
    cursor: 'pointer',

    '& svg': {
      fill: Theme.palette.primary.light,
    },
  },
  infoTooltipTitle: {
    fontFamily: Theme.typography.base.semiBold,
    fontSize: Theme.typography.size[2],
    color: Theme.palette.primary.main,
    marginBottom: '10px',
  },
  infoTooltipDescription: {
    fontFamily: Theme.typography.base.regular,
    display: 'flex',
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[750],
    lineHeight: '150%',
    marginTop: 10,
    [Theme.breakpoints.up('xl')]: {
      marginTop: 0,
    },
  },
}));

export default useStyles;
